import { render, staticRenderFns } from "./userBaseMessage.vue?vue&type=template&id=4263afe0&scoped=true&"
import script from "./userBaseMessage.vue?vue&type=script&lang=js&"
export * from "./userBaseMessage.vue?vue&type=script&lang=js&"
import style0 from "./userBaseMessage.vue?vue&type=style&index=0&id=4263afe0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4263afe0",
  null
  
)

export default component.exports